import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import 'rc-collapse/assets/index.css';
import Collapse, { Panel } from 'rc-collapse';


const FeaturesAccordionItemQuestionItem = ({ translate, ownprops }) => {
  return (
        <Collapse accordion={true}>
            <Panel header={translate(ownprops.value.qtitle)} headerClass="accordion">{translate(ownprops.value.qanswer)}</Panel>
        </Collapse>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    ownprops: ownProps
  };
};

export default connect(mapStateToProps)(FeaturesAccordionItemQuestionItem);


// WEBPACK FOOTER //
// ./src/components/features/featuresaccordion-itemquestion.jsx